import { apiRequest } from "../services/apiRequest"
import { api } from "../services/axios"

export const ReferralsApi = {
  getDashboardOverview: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.filterType) params.set("filterType", query.filterType)
    if (query.startDate) params.set("startDate", query.startDate)
    if (query.endDate) params.set("endDate", query.endDate)
    const qs = params.toString()
    const url = `/account/admin/referral/dashboard-overview/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  getTopReferrals: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.country) params.set("country", query.country)
    if (query.filterType) params.set("filterType", query.filterType)
    if (query.startDate) params.set("startDate", query.startDate)
    if (query.endDate) params.set("endDate", query.endDate)
    if (query.page != null && query.page > 0)
      params.set("page", String(query.page))
    const qs = params.toString()
    const url = `/account/admin/referral/top-referrals/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  getReferralUsers: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.page != null && query.page > 0)
      params.set("page", String(query.page))
    if (query.page_size != null && query.page_size > 0)
      params.set("page_size", String(query.page_size))
    if (query.search && String(query.search).trim())
      params.set("search", String(query.search).trim())
    if (query.status) params.set("status", String(query.status))
    const qs = params.toString()
    const url = `/account/admin/referral/users/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  getReferralUserDetail: async (id) => {
    const userId = String(id ?? "").trim()
    if (!userId) throw new Error("Missing user id")
    return await apiRequest("get", `/account/admin/referral/users/${userId}/`)
  },

  deleteReferralUser: async (id) => {
    const userId = String(id ?? "").trim()
    if (!userId) throw new Error("Missing user id")
    return await apiRequest("delete", `/account/admin/referral/users/${userId}/`)
  },

  exportReferralUsersCsv: async () => {
    return await api({
      method: "get",
      url: "/account/admin/referral/users/?export=csv",
      responseType: "blob",
      headers: {
        Accept: "text/csv, application/octet-stream, */*",
      },
    })
  },

  getActivityLogs: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.activity_type) params.set("activity_type", query.activity_type)
    if (query.page != null && query.page > 0)
      params.set("page", String(query.page))
    if (query.page_size != null && query.page_size > 0)
      params.set("page_size", String(query.page_size))
    if (query.status) params.set("status", String(query.status))
    if (query.search && String(query.search).trim())
      params.set("search", String(query.search).trim())
    const qs = params.toString()
    const url = `/account/admin/referral/activity-logs/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  exportActivityLogsCsv: async () => {
    return await api({
      method: "get",
      url: "/account/admin/referral/activity-logs/?export=csv",
      responseType: "blob",
      headers: {
        Accept: "text/csv, application/octet-stream, */*",
      },
    })
  },

  getRecentActivity: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.type) params.set("type", String(query.type))
    if (query.filterType) params.set("filterType", String(query.filterType))
    if (query.startDate) params.set("startDate", String(query.startDate))
    if (query.endDate) params.set("endDate", String(query.endDate))
    if (query.page != null && query.page > 0)
      params.set("page", String(query.page))
    if (query.page_size != null && query.page_size > 0)
      params.set("page_size", String(query.page_size))
    const qs = params.toString()
    const url = `/account/admin/referral/recent-activity/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  getRewardInfo: async () => {
    return await apiRequest("get", `/account/dashboard/referral/reward-info/`)
  },

  getCustomCodes: async () => {
    return await apiRequest("get", `/account/admin/referral/custom-codes/`)
  },

  createCustomCode: async (payload) => {
    return await apiRequest("post", `/account/admin/referral/custom-codes/`, {
      email: String(payload.email ?? "").trim(),
      referral_code: String(payload.referral_code ?? "").trim(),
    })
  },

  updateSettings: async (payload) => {
    return await apiRequest("patch", `/account/admin/referral/settings/`, payload)
  },

  getSettings: async () => {
    return await apiRequest("get", `/account/admin/referral/settings/`)
  },

  getRewardsManagement: async (query = {}) => {
    const params = new URLSearchParams()
    if (query.page != null && query.page > 0)
      params.set("page", String(query.page))
    if (query.page_size != null && query.page_size > 0)
      params.set("page_size", String(query.page_size))
    if (query.search && String(query.search).trim())
      params.set("search", String(query.search).trim())
    if (query.status) params.set("status", String(query.status))
    const qs = params.toString()
    const url = `/account/admin/referral/rewards-management/${qs ? `?${qs}` : ""}`
    return await apiRequest("get", url)
  },

  exportRewardsManagementCsv: async (query = {}) => {
    const params = new URLSearchParams()
    params.set("export", "csv")
    if (query.search && String(query.search).trim())
      params.set("search", String(query.search).trim())
    if (query.status) params.set("status", String(query.status))
    const qs = params.toString()
    return await api({
      method: "get",
      url: `/account/admin/referral/rewards-management/?${qs}`,
      responseType: "blob",
      headers: {
        Accept: "text/csv, application/octet-stream, */*",
      },
    })
  },

  patchReferralReward: async (id, body) => {
    const rewardId = String(id ?? "").trim()
    if (!rewardId) throw new Error("Missing reward id")
    return await apiRequest(
      "patch",
      `/account/admin/referral/rewards/${rewardId}/`,
      body
    )
  },
}
